import Vue from 'vue'
import Router from 'vue-router'
// import firebase from 'firebase/app'
import {firebase} from '@/plugins/firebase.js';
import Login from './views/Login.vue'
import automation from './views/Automation.vue'
import dashboard from './views/Dashboard.vue'
import assets from './views/Assets.vue'
import broadcast from './views/Broadcast.vue'
import users from './views/Users.vue'
import tools from './views/Tools.vue'
import settings from './views/Settings.vue'
import settingsnewbot from './views/Settings-newbot.vue'
import integrations from './views/Integrations.vue'
import analysis from './views/Analysis.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/automation/:s_menu/:page_id',
      name: 'automation',
      component: automation,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: dashboard,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/assets/:page_id',
      name: 'assets',
      component: assets,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/analysis/:page_id',
      name: 'analysis',
      component: analysis,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/broadcast/:s_menu/:page_id',
      name: 'broadcast',
      component: broadcast,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/users/:page_id',
      name: 'users',
      component: users,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/tools/:s_menu/:page_id',
      name: 'tools',
      component: tools,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/settings/:s_menu/:page_id',
      name: 'settings',
      component: settings,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/settings-newbot',
      name: 'settings-newbot',
      component: settingsnewbot,
      meta: {
        requiresAuth:true
      }
    },
    {
      path: '/integrations/:page_id',
      name: 'integrations',
      component: integrations,
      meta: {
        requiresAuth:true
      }
    }
  ]
})


router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().onAuthStateChanged((user) => {
    if (requiresAuth && !user) {
      next('/')
  } else if (requiresAuth && user) {
      next()
  }  else if (!requiresAuth && user) {
    next('/dashboard')
  } else {
      next()
  }

   })
})


export default router